import React from "react";
import appsmithLogo from "../../assets/appsmithLogo.png";
import phonePeLogo from "../../assets/phonePeLogo.png";
import freepikLogo from "../../assets/freepickLogo.png";
import adaniLogo from "../../assets/adaniLogo.png";
import razorpayLogo from "../../assets/razorpayLogo.png";
import jindalSteelLogo from "../../assets/jindalSteelLogo.png";
import zanistaaiLogo from "../../assets/zanistaaiLogo.jpeg";
import savvyLogo from "../../assets/savvyLogo.png";
import zooxaiLogo from "../../assets/zooxaiLogo.png";

const Companions: React.FC = () => {
  const companies = [
    { name: "Appsmith", logo: appsmithLogo },
    { name: "PhonePe", logo: phonePeLogo },
    { name: "Freepik", logo: freepikLogo },
    { name: "Adani", logo: adaniLogo },
    { name: "Razorpay", logo: razorpayLogo },
    { name: "Jindal Steel", logo: jindalSteelLogo },
    { name: "Zanista AI", logo: zanistaaiLogo },
    { name: "Savvy Group", logo: savvyLogo },
    { name: "Zoox AI", logo: zooxaiLogo },
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-16">
        <div className="text-center mb-12">
           <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold  text-gray-900 mb-4">
            Trusted by 
          </h2>
         
        </div>

        <div className="relative overflow-hidden">
          <div className="flex animate-scroll space-x-6 sm:space-x-8 md:space-x-12">
            {[...companies, ...companies].map((company, index) => (
              <div
                key={`${company.name}-${index}`}
                className="flex-shrink-0 flex items-center justify-center w-32 h-16 sm:w-40 sm:h-20 md:w-48 md:h-24 lg:w-56 lg:h-28  rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
              >
                <img
                  src={company.logo}
                  alt={company.name}
                  className="max-w-24 max-h-8 sm:max-w-32 sm:max-h-12 md:max-w-40 md:max-h-16 lg:max-w-48 lg:max-h-20 object-contain transition-all duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-100%);
          }
        }

        .animate-scroll {
          animation: scroll 30s linear infinite;
        }

        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default Companions;
